module.exports = __webpack_public_path__ + "static/media/ezra.55d5cf1c.jpg";